// Translation for ta
export const ta = {
        common: {
            save: 'சேமி',
            cancel: 'ரத்துசெய்',
            close: 'மூடு',
            delete: 'நீக்கு',
            edit: 'திருத்து',
            activate: 'செயல்படுத்து',
            add: 'சேர்',
            saving: 'சேமிக்கப்படுகிறது...',
            loading: 'ஏற்றப்படுகிறது...',
            active: 'செயலில்',
            inUse: 'பயன்பாட்டில்',
            test: 'சோதனை',
            searchApps: 'பயன்பாடுகளைத் தேடு...',
            betaBanner: 'பீட்டா - சேவை இன்னும் கிடைக்கவில்லை!'
        },
        header: {
            creditBalance: 'இருப்பு',
            minutes: 'நிமிடங்கள்'
        },
        auth: {
            signIn: 'உள்நுழை',
            signUp: 'பதிவு செய்',
            username: 'பயனர் பெயர்',
            password: 'கடவுச்சொல்',
            continue: 'தொடரவும்',
            noAccount: 'கணக்கு இல்லையா?',
            hasAccount: 'ஏற்கனவே கணக்கு உள்ளதா?',
            loginError: 'உள்நுழைவு தோல்வியடைந்தது',
            invalidCredentials: 'தவறான பயனர் பெயர் அல்லது கடவுச்சொல்',
            rateLimited: 'அதிக உள்நுழைவு முயற்சிகள். தயவுசெய்து சிறிது நேரம் காத்திருக்கவும்.',
            sessionExpired: 'உங்கள் அமர்வு முடிந்துவிட்டது. தயவுசெய்து புதிய மேஜிக் இணைப்பைப் பயன்படுத்தவும்.',
            magicLinkInvalid: 'உள்நுழைவு இணைப்பு தவறானது அல்லது காலாவதியானது.',
            magicLinkSuccess: 'வரவேற்கிறோம்! நீங்கள் வெற்றிகரமாக உள்நுழைந்துள்ளீர்கள்.',
            magicLinkProcessing: 'உள்நுழைவு செயலாக்கப்படுகிறது...',
            connectionError: 'இணைப்பு பிழை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.'
        },
        profile: {
            myProgress: 'எனது கற்றல் முன்னேற்றம்',
            signOut: 'வெளியேறு',
            plan: 'திட்டம்: '
        },
        settings: {
            title: 'அமைப்புகள்',
            tabs: {
                uiSettings: 'UI அமைப்புகள்',
                systemPrompt: 'கணினி வரியில்',
                llmProfiles: 'LLM சுயவிவரங்கள்',
                ttsProfiles: 'TTS சுயவிவரங்கள்',
                language: 'மொழி',
            },
            uiSettings: {
                title: 'பயனர் இடைமுகம்',
                themeMode: 'தீம் பயன்முறை',
                darkMode: 'இருண்ட பயன்முறை',
                lightMode: 'ஒளி பயன்முறை',
                themeColor: 'தீம் நிறம்',
                themeColorDesc: 'பொத்தான்கள், சின்னங்கள் மற்றும் சிறப்பம்சங்களுக்கான உச்சரிப்பு நிறத்தைத் தேர்வு செய்யவும்',
                background: 'பின்னணி',
                backgroundDesc: 'உங்கள் பணியிடத்திற்கு ஒரு பின்னணியைத் தேர்வு செய்யவும்',
                selectBackgroundColor: 'பின்னணி நிறத்தைத் தேர்வு செய்யவும்',
                backgrounds: {
                    cyberSchooling: 'சைபர் ஸ்கூலிங்',
                    focus: 'கவனம்',
                    concentration: 'செறிவு',
                    relaxation: 'ஓய்வு',
                    lianas: 'லியானாஸ்',
                    color: 'நிறம்'
                },
                backgroundColors: {
                    deepDark: 'ஆழ்ந்த இருள்',
                    darkGrey: 'அடர் சாம்பல்',
                    midnightBlue: 'மிட்நைட் ப்ளூ',
                    indigo: 'இண்டிகோ',
                    darkTeal: 'அடர் டீல்',
                    brown: 'பழுப்பு',
                    darkRed: 'அடர் சிவப்பு',
                    deepPurple: 'அடர் ஊதா',
                    pureWhite: 'தூய வெள்ளை',
                    softWhite: 'மென்மையான வெள்ளை',
                    lightGrey: 'வெளிர் சாம்பல்',
                    paleBlue: 'வெளிர் நீலம்',
                    paleGreen: 'வெளிர் பச்சை',
                    paleOrange: 'வெளிர் ஆரஞ்சு',
                    lavender: 'லாவெண்டர்',
                    blueGrey: 'ப்ளூ கிரே'
                }
            },
            systemPrompt: {
                label: 'கணினி வரியில்:',
                placeholder: 'கணினி வரியில் ஏற்றப்படுகிறது...',
                emptyError: 'கணினி வரியில் காலியாக இருக்கக்கூடாது!',
                saveSuccess: '✓ கணினி வரியில் வெற்றிகரமாக சேமிக்கப்பட்டது!',
                loadError: 'கணினி வரியை ஏற்றுவதில் பிழை',
                saveError: 'சேமிப்பதில் பிழை'
            },
            llmProfiles: {
                addButton: '+ புதிய இணைப்பைச் சேர்',
                newConnection: 'புதிய இணைப்பு',
                editConnection: 'இணைப்பைத் திருத்து',
                emptyState: 'LLM இணைப்புகள் எதுவும் கிடைக்கவில்லை. ஒன்றைச் சேர்க்க கீழே கிளிக் செய்யவும்.',
                loadingProfiles: 'சுயவிவரங்கள் ஏற்றப்படுகின்றன...',
                nameLabel: 'பெயர் *',
                namePlaceholder: 'எ.கா. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API விசை *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'மாதிரி *',
                modelPlaceholder: 'gpt-4, mistral-tiny போன்றவை.',
                allFieldsRequired: 'அனைத்து புலங்களும் நிரப்பப்பட வேண்டும்!',
                saveSuccess: '✓ சுயவிவரம் வெற்றிகரமாக சேமிக்கப்பட்டது!',
                deleteConfirm: 'நீங்கள் உண்மையில் "{name}" ஐ நீக்க விரும்புகிறீர்களா?',
                profileNotFound: 'சுயவிவரம் காணப்படவில்லை!',
                loadError: 'சுயவிவரங்களை ஏற்றுவதில் பிழை',
                saveError: 'சேமிப்பதில் பிழை',
                activateError: 'செயல்படுத்துவதில் பிழை',
                deleteError: 'நீக்குவதில் பிழை',
                modelInfo: 'மாதிரி: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ புதிய குரலைச் சேர்',
                newVoice: 'புதிய குரல்',
                editVoice: 'குரலைத் திருத்து',
                emptyState: 'TTS சுயவிவரங்கள் எதுவும் கிடைக்கவில்லை. ஒன்றைச் சேர்க்க கீழே கிளிக் செய்யவும்.',
                loadingProfiles: 'TTS சுயவிவரங்கள் ஏற்றப்படுகின்றன...',
                nameLabel: 'பெயர்',
                namePlaceholder: 'எ.கா. எனது ElevenLabs ஆடம்',
                providerLabel: 'வழங்குநர்',
                providerPlaceholder: 'எ.கா. ElevenLabs, OpenAI, Piper',
                providerPiper: 'பைப்பர் (உள்ளூர்)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API விசை *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'மாதிரி ID *',
                modelIdPlaceholder: 'எ.கா. eleven_monolingual_v1',
                voiceIdLabel: 'குரல் ID',
                voiceIdPlaceholder: 'எ.கா. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'அனைத்து புலங்களும் நிரப்பப்பட வேண்டும்!',
                saveSuccess: '✓ TTS சுயவிவரம் வெற்றிகரமாக சேமிக்கப்பட்டது!',
                deleteConfirm: 'நீங்கள் உண்மையில் "{name}" ஐ நீக்க விரும்புகிறீர்களா?',
                loadError: 'TTS சுயவிவரங்களை ஏற்றுவதில் பிழை',
                saveError: 'சேமிப்பதில் பிழை',
                activateError: 'செயல்படுத்துவதில் பிழை',
                deleteError: 'நீக்குவதில் பிழை'
            },
            language: {
                title: 'மொழியைத் தேர்வு செய்யவும்',
                description: 'பயனர் இடைமுகத்திற்கு உங்களுக்கு விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்'
            },
        },
        chat: {
            ready: 'தயார்',
            start: 'தொடங்கு',
            stop: 'நிறுத்து',
            initialMessage: 'நிகழ்நேர உரையாடலுக்குத் தொடங்கு என்பதைக் கிளிக் செய்யவும்.',
            listening: 'கவனித்தல்...',
            speaking: 'தோர்ஸ்டன் பேசுகிறார்...',
            userLabel: 'நீங்கள்',
            aiLabel: 'AI',
            modalTitle: 'தோர்ஸ்டன் AI அரட்டை',
            inputPlaceholder: 'செய்தியைத் தட்டச்சு செய்யவும்...',
            send: 'அனுப்பு',
            loginRequired: 'இந்தச் சேவையைப் பயன்படுத்த தயவுசெய்து உள்நுழையவும்.',
            loginButton: 'இப்போதே உள்நுழைக',
            magicLinkRequired: 'உள்நுழைய தயவுசெய்து மேஜிக் இணைப்பைப் பயன்படுத்தவும்.',
            creditLimitError: 'உங்கள் மணிநேர ஒதுக்கீடு முடிந்துவிட்டது. தொடர தயவுசெய்து உங்கள் திட்டத்தை (மீடியம்/பிரீமியம்) மேம்படுத்தவும்.',
            serviceDisabled: 'அரட்டை சேவை தற்போது கிடைக்கவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.'
        },
        notifications: {
            error: 'பிழை',
            success: 'வெற்றி',
            info: 'தகவல்',
            unknownError: 'தெரியாத பிழை ஏற்பட்டது'
        },
        cookie: {
            message: 'சிறந்த பயனர் அனுபவத்தை வழங்க இந்த இணையதளம் குக்கீகளைப் பயன்படுத்துகிறது.',
            accept: 'ஏற்றுக்கொள்'
        },
        curriculum: {
                buttonLabel: 'பாடத்திட்டம்',
                buttonTitle: 'பாடத்திட்ட உள்ளடக்கத்தைக் காட்டு',
                modalTitle: '{app} பாடத்திட்டம்',
                sections: {
                    topic: 'பாடத்திட்ட தலைப்பு',
                    explanation: 'குழந்தைகளுக்கான விளக்கம்',
                    studentProfile: 'மாணவர் சுயவிவரம்'
                },
                topic: {
                    empty: 'இந்த மைக்ரோ-ஆப்புடன் பின்தளத்தில் எந்த பாடத்திட்ட தலைப்பும் இணைக்கப்படவில்லை.',
                    missingDetail: 'இந்த மைக்ரோ-ஆப்பிற்கான விரிவான பாடத்திட்ட தரவு பின்தளத்தில் இன்னும் கிடைக்கவில்லை.',
                    learningGoals: 'கற்றல் இலக்குகள்',
                    prerequisites: 'முன்நிபந்தனைகள்',
                    unitLabel: 'அலகு',
                    durationLabel: 'கால அளவு',
                    difficultyLabel: 'சிரம நிலை',
                    hours: 'மணி',
                    minutes: 'நிமி'
                },
                explanation: {
                    empty: 'குழந்தைகளுக்கான விளக்கம் எதுவும் இல்லை.',
                    loadingPrepare: 'AI விளக்கத்தை தயாரிக்கிறது',
                    loadingExplain: 'AI தலைப்பை குழந்தைகளுக்கான மொழியில் விளக்குகிறது',
                    requestFailed: 'குழந்தைகளுக்கான விளக்கத்தை உருவாக்க முடியவில்லை.'
                },
                studentProfile: {
                    country: 'நாடு',
                    region: 'மாநிலம் / பகுதி',
                    schoolType: 'பள்ளி வகை',
                    grade: 'வகுப்பு',
                    noContext: 'மாணவர் சூழல் எதுவும் இல்லை.',
                    childProfileNotFound: 'தற்போதைய உள்நுழைவுக்கான மாணவர் சுயவிவரம் பின்தளத்தில் காணப்படவில்லை.',
                    loginProfileIncomplete: 'உள்நுழைவு சுயவிவரத்தில் இன்னும் முழுமையான மாணவர் சூழல் இல்லை.',
                    educationContextNotFound: 'மாணவர் சுயவிவரம் கிடைத்தது, ஆனால் பாடத்திட்ட ஒதுக்கீடு எதுவும் அமைக்கப்படவில்லை.',
                    noToken: 'உள்நுழைந்த மாணவர் எவரும் இல்லை.'
                },
                errors: {
                    signInRequired: 'பாடத்திட்டத்தைப் பார்க்க உள்நுழையவும்.',
                    appIdMissing: 'ஆப் ID இல்லை.',
                    loadFailed: 'பாடத்திட்ட தரவை ஏற்ற முடியவில்லை.'
                }
            }
    };
